exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "[dir] .moduleStatsTable_tableStyle__2SvY7{margin-top:.25rem}", ""]);

// Exports
exports.locals = {
	"tableStyle": "moduleStatsTable_tableStyle__2SvY7"
};